<template>
  <svg
    viewBox="0 0 534 926"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M267.2 926H0l266.8-463L0 0h267.2L534 463 267.2 926Z"
      fill="currentColor"
    />
  </svg>
</template>
